export const capacityTranslationsEn = {
  numOfOrders: 'Number of activities',
  numOfPeople: 'Number of people',
};
